<template lang="html">
    <div>
      <accordions>
      <accordion
        :title="fullName"
        subtitle="Your account"
        :action_type="{value:'internal_link'}"
        :action_page="{url: '/settings/my-account'}"
      />
        <accordion
        title="Booking history"
        :action_type="{value:'internal_link'}"
        :action_page="{url: '/settings/booking-history'}"
      />
        <accordion
            title="Invite friend"
            :action_type="{value:'internal_link'}"
            :action_page="{url: '/settings/invite-friend'}"
        />
    </accordions>
    </div>


</template>

<script>
import Accordions from '@/sections/accordions/Accordions'
import Accordion from '@/components/partials/Accordion'

export default {
  name: 'Settings',
  components: {
    Accordions,
    Accordion
  },
  computed: {
    fullName () {
      const account = {...this.$store.state.userprofile.profile}
      if (!account) {
        return ''
      }
      return `${account.first_name} ${account.last_name}`
    },
    settingsContent () {
      console.log('this.$store.state.settings.settings', this.$store.state.settings.settings)
      return this.$store.state.settings.settings
    }
  },
  methods: {
    async fetchSettings () {
      await this.$store.dispatch('settings/fetchSettings')
    }
  },
  created () {
    this.fetchSettings()
  }
}
</script>
<style lang="scss">
  .fine-print {
    margin: 40px 0;
  }
</style>
